export default "__VITE_ASSET__DsLb$JS8__"